/* Nordhaus page layout tweaks (draft theme). */
(function () {
  'use strict';

  // 1. "Planning and owner guides" sits directly under the lead form
  //    ("Not sure which one is right for you?") on any page that has both.
  //    Sections are ordered in each template's JSON; moving it here means one
  //    change covers every product page instead of editing dozens of templates.
  //    Outdoor sauna product pages are the exception: there the guides take the
  //    place of the hidden "Delivery and installation" section, set in their
  //    template JSON, so they are left where the template puts them.
  function moveGuides() {
    if (/(^|\s)template-product-outdoor/.test(document.body.className)) return;

    var form = document.querySelector('.nh-contact');
    var formSection = form && form.closest('.shopify-section');
    if (!formSection) return;

    var guides = document.querySelector('[id$="__nh_planning_guides"]');
    if (!guides) {
      var h = Array.prototype.find.call(document.querySelectorAll('.nhs-wrap .nhs-h'), function (el) {
        return /owner guides/i.test(el.textContent);
      });
      guides = h && h.closest('.shopify-section');
    }
    if (!guides || guides === formSection || formSection.nextElementSibling === guides) return;

    formSection.insertAdjacentElement('afterend', guides);
  }

  // 2. Spec drop down titles say what is inside them, since the grey
  //    subheading is hidden on mobile.
  var TITLES = {
    'Construction': 'Construction and finish',
    'Power': 'Power and electrical'
  };
  function clarifySpecTitles() {
    document.querySelectorAll('.nh-sp__group-title').forEach(function (el) {
      var t = el.textContent.trim();
      if (TITLES[t]) el.textContent = TITLES[t];
    });
  }

  function run() { moveGuides(); clarifySpecTitles(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
})();
